export const loadScript = (
    src: string,
    callback: () => void,
    errorCallback: (error: ErrorEvent) => void,
): void => {
    const script = document.createElement('script');
    script.src = src;

    const handleLoad = () => {
        callback();
        cleanup();
    };

    const handleError = (error: ErrorEvent) => {
        errorCallback(error);
        cleanup();
    };

    const cleanup = () => {
        script.removeEventListener('load', handleLoad);
        script.removeEventListener('error', handleError);
    };

    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);

    document.head.appendChild(script);
};
